import { render, staticRenderFns } from "./PresellOrderGoods.vue?vue&type=template&id=715a49b2&scoped=true&"
import script from "./PresellOrderGoods.vue?vue&type=script&lang=js&"
export * from "./PresellOrderGoods.vue?vue&type=script&lang=js&"
import style0 from "./PresellOrderGoods.vue?vue&type=style&index=0&id=715a49b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715a49b2",
  null
  
)

export default component.exports